(function () {
    'use strict';

    angular
        .module('skillsApp')
        .factory('translationsLoader', translationsLoader);

    function translationsLoader($q, $timeout) {

        var translations = {};

        translations.en = {
            "a_problem_occurred": "A problem occurred",
            "active_accounts": "Active accounts",
            "activities": "Activities",
            "activity": "Activity",
            "add": "Add",
            "added": "Added",
            "add_block": "Add block",
            "add_attachment(s)": "Add attachment(s)",
            "add_cluster": "Add category",
            "add_examiners": "Add examiners",
            "add_mark": "Add mark",
            "add_skill": "Add skill",
            "add_users": "Add users",
            "admin": "Admin",
            "administrators": "Administrators",
            "agenda": "Agenda",
            "all": "All",
            "all_available_departments": "All available departments",
            "all_available_functions": "All available functions",
            "anonymize_reports_for_report_viewers": "Anonymize reports for report viewers",
            "approved": "Approved",
            "are_allowed_to_customize_blocks": "are allowed to customize blocks",
            "are_allowed_to_extend_the_validity": "are allowed to extend the validity",
            "are_you_sure_you_want_to_delete_this_mark?": "Are you sure you want to delete this mark?",
            "are_you_sure_you_want_to_go_ahead?": "Are you sure you want to go ahead?",
            "are_you_sure_you_want_to_register_again?": "Are you sure you want to register_again?",
            "are_you_sure_you_want_to_request_a_review?": "Are you sure you want to request a review?",
            "are_you_sure_you_want_to_restart_this_elearning?": "Are you sure you want to restart this elearning?",
            "assess_employees": "Assess employees",
            "assessment_result": "Assessment result",
            "assessment_requested": "Assessment requested",
            "assessment_requests": "Assessment requests",
            "assessor": "Assessor",
            "assessors": "Assessors",
            "assessors_are_allowed_to_manage_exemptions": "Assessors are allowed to manage exemptions",
            "assign": "Assign",
            "assigned": "Assigned",
            "assigned_to": "Assigned to",
            "assignments": "Assignments",
            "attachment(s)": "Attachment(s)",
            "authorizations": "Authorizations",
            "back": "Back",
            "both": "Both",
            "cancel": "Cancel",
            "catalogitem_not_found": "This activity is not available.",
            "categories": "Categories",
            "category": "Category",
            "change_category": "Change category",
            "change_request": "Change request",
            "classical": "Classical",
            "classical_theory_lesson": "Classical theory lesson",
            "clear_all": "Clear all",
            "close": "Close",
            "cluster": "Cluster",
            "clusteraction_already_exists": "There is already a skill with the same name",
            "cluster_already_exists": "There is already a category with the same name",
            "cluster_not_empty": "Can't delete category because it still contains one or more skills",
            "colleague": "Colleague",
            "competence_passport": "Competence passport",
            "complete": "Complete",
            "completed_on": "Completed on",
            "compulsory": "Compulsory",
            "confirm_delete_cluster": "Are you sure you want to delete this category?",
            "confirm_delete_clusteraction": "Are you sure you want to delete this skill?",
            "confirm_delete_examiner_assignments": "Are you sure you want to delete all assignments for this examiner?",
            "confirm_delete_individual_quality": "Are you sure you want to delete this individual skill?",
            "confirm_delete_skill": "Are you sure you want to delete this skill?",
            "connected": "Connected",
            "copy_assessors": "Copy assessors",
            "create_new_skill": "Create new skill",
            "current_selection": "Current selection",
            "date": "Date",
            "delete": "Delete",
            "delete_cluster": "Delete category",
            "delete_clusteraction": "Delete skill",
            "delete_examiner_assignments": "Delete all assignments for this examiner",
            "delete_individual_quality": "Delete individual skill",
            "delete_mark": "Delete mark",
            "delete_skill": "Delete skill",
            "deleted": "Deleted",
            "department": "Department",
            "departments": "Departments",
            "departments_report": "Departments report",
            "description": "Description",
            "description_(optional)": "Description (optional)",
            "disabled_accounts": "Disabled accounts",
            "down": "Down",
            "download": "Download",
            "edit": "Edit",
            "edit_cluster": "Edit category",
            "edit_skill": "Edit skill",
            "elearning": "elearning",
            "employees": "Employees",
            "empty_values": "Empty values",
            "enroll": "Enroll",
            "error": "Error",
            "error_device_time_problem": "Check the date / time setting of your system because it appears to be incorrect",
            "error_while_saving": "Error while saving",
            "examiner": "Examiner",
            "examiners": "Examiners",
            "exemption": "Exemption",
            "expiry_date": "Expiry date",
            "export_examiner_assignments": "Copy assignments to other user",
            "failed": "Failed",
            "filter_by_category_or_skill": "Filter by category or skill",
            "filter_by_skill": "Filter by skill",
            "filter_info_assigned_to": "Filter skills on function or individual assignment",
            "filter_info_connected": "Filter skills that are related to the current function or individual assignment",
            "filter_info_does_not_apply": "Filter skills for which the does not apply setting is turned on or not",
            "filter_info_status": "Filter skills on status approved or not_approved",
            "filtered_on": "Filtered on",
            "for_one_or_more_activities_no_assessors_have_been_added_yet": "For one or more activities no assessors have been added yet",
            "function": "Function",
            "function_and_individual": "Function and Individual",
            "functions": "Functions",
            "functions_found": "Functions found",
            "have_you_read_the_manual?": "Have you read the manual?",
            "have_you_read_the_protocol?": "Have you read the protocol?",
            "http(s)_or_ftp_link": "Http(s) or ftp link",
            "import_examiner_assignments": "Copy assignments from other users",
            "inapplicable": "Inapplicable",
            "incomplete": "Incomplete",
            "individual": "Individual",
            "individual_skills": "Individual skills",
            "invalid": "Invalid",
            "invalid_date": "Invalid date",
            "invalid_examiner": "Invalid assessor",
            "it's_not_possible_to_assess_yourself": "It's not possible to assess yourself",
            "last_result": "Last result",
            "maintenance": "Maintenance",
            "maintenance_failed_to_initialize_skills": "Due to an unexpected failure, the competence passport is currently unavailable. Please try again later. We apologize for the inconvenience.",
            "maintenance_message": "Due to maintenance, the competence passport is currently unavailable. Please try again later. We apologize for the inconvenience.",
            "managers": "Managers",
            "managers_are_allowed_to_manage_child_departments": "Managers are allowed to manage child departments",
            "managers_are_allowed_to_manage_skill_assignments": "Managers are allowed to manage skill assignments",
            "manual": "Manual",
            "maximum_validity_reached": "Maximum validity is reached",
            "medical_and_technical_aids": "Medical and Technical Aids",
            "month(s)": "Month(s)",
            "name": "Name",
            "name_(required)": "Name (required)",
            "no": "No",
            "no_exemption": "No exemption",
            "no_results_yet": "No results yet",
            "no_skills_available_to_manage_examiners": "There are no skills available for you to manage examiners.",
            "non_current_etag": "The document you are trying to save has been changed in the meantime. As a result, your changes have not been saved.",
            "not_approved": "Not approved",
            "not_assigned": "Not assigned",
            "not_authorized": "Not authorized",
            "not_yet_finalized": "Not yet finalized",
            "number_required": "Number required",
            "of": "of",
            "off": "Off",
            "ok": "Ok",
            "on": "On",
            "only_add_existing_combinations": "Only add existing combinations",
            "open": "Open",
            "open_link": "Open link",
            "optional": "Optional",
            "or": "or",
            "passed": "Passed",
            "paste_assessors": "Paste assessors",
            "peerassessment": "Peer assessment",
            "peer_assessment": "Peer assessment",
            "percentage": "Percentage",
            "practical": "Practice test",
            "practice": "Practice",
            "practice_test": "Practice test",
            "preserve_selected_examiners": "Preserve selected examiners",
            "progress": "Progress",
            "protocol": "Protocol",
            "read": "Read",
            "reason_of_exemption": "Reason of exemption",
            "recommended": "Recommended",
            "register_again": "Register again",
            "remark": "Remark",
            "remove_existing_assignments": "Remove existing assignments",
            "reports": "Reports",
            "request": "Request",
            "restart": "Restart",
            "results": "Results",
            "revoke_request": "Revoke request",
            "request_revoked": "Request revoked",
            "reserved_and_risky_actions": "Reserved and Risky Actions",
            "rights": "Rights",
            "save": "Save",
            "save_and_add_activities": "Save and add activities",
            "saving_this_record_failed_because_it_was_updated_by_someone_else": "Saving this record failed because it was updated by someone else",
            "search": "Search",
            "search_and_select_functions": "Search and select functions",
            "search_for_a_user_with_skills": "Search for a user with skills",
            "search_for_examiners": "Search for examiners",
            "search_for_groups": "Search for groups",
            "search_for_users": "Search for users",
            "search_for_users_and/or_groups": "Search for users and/or groups",
            "search_for_users_from_your_department": "Search for users from your department",
            "search_functions": "Search functions",
            "searching": "Searching",
            "select": "Select",
            "select_a_skill_to_modify_assignments": "Select a skill to modify assignments",
            "select_activity": "Select activity",
            "select_all": "Select all",
            "select_departments_or_functions": "Select one or more departments and functions",
            "select_department_/_function": "Select department / function",
            "select_functions": "Select functions",
            "select_an_employee": "Select an employee",
            "select_the_colleague_who_is_going_to_assess_your_work": "Select the colleague who is going to assess your work",
            "selected": "selected",
            "selected_department_/_function_combinations": "Selected department / function combinations",
            "settings": "Settings",
            "show_empty_values": "Show empty values",
            "skill": "Skill",
            "skills": "Skills",
            "skills_report": "Skills report",
            "skillslabtest": "Skillslab test",
            "skillslabtraining": "Skillslab training",
            "skillslab_test": "Skillslab test",
            "skillslab_training": "Skillslab training",
            "some_mandatory_fields_have_not_yet_been_filled": "Some mandatory fields have not yet been filled",
            "specific_departments": "Specific departments",
            "specific_functions": "Specific functions",
            "status": "Status",
            "successfully_deleted": "Successfully deleted",
            "successfully_saved": "Successfully saved",
            "the_minimum_number_of_required_activities_is": "The minimum number of required activities is",
            "the_result_is_valid_until": "The result is valid until",
            "the_total_files_size_may_not_exceed": "The total files size may not exceed",
            "total": "Total",
            "trainer": "Trainer",
            "trainingonthejob": "Training on the job",
            "training_on_the_job": "Training on the job",
            "type": "Type",
            "up": "Up",
            "update_validity_for_existing_assignments": "Overwrite validity for existing assignments",
            "valid": "Valid",
            "validity": "Validity",
            "various": "Various",
            "writtentest": "Written test",
            "written_test": "Written test",
            "yes": "Yes"
        };

        translations.nl = {
            "a_problem_occurred": "Er is een probleem opgetreden",
            "active_accounts": "Actieve accounts",
            "activities": "Activiteiten",
            "activity": "Activiteit",
            "add": "Toevoegen",
            "added": "Toegevoegd",
            "add_block": "Blok toevoegen",
            "add_attachment(s)": "Bijlage(n) toevoegen",
            "add_cluster": "Categorie toevoegen",
            "add_examiners": "Beoordelaars toevoegen",
            "add_mark": "Beoordeling toevoegen",
            "add_skill": "Bekwaamheid toevoegen",
            "add_users": "Gebruikers toevoegen",
            "admin": "Beheer",
            "administrators": "Beheerders",
            "agenda": "Agenda",
            "all": "Alle",
            "all_available_departments": "Alle beschikbare afdelingen",
            "all_available_functions": "Alle beschikbare functies",
            "anonymize_reports_for_report_viewers": "Rapport gebruikers mogen alleen geanonimiseerde rapporten zien",
            "approved": "Bekwaam",
            "are_allowed_to_customize_blocks": "mogen blokken aanpassen",
            "are_allowed_to_extend_the_validity": "mogen de geldigheid verlengen",
            "are_you_sure_you_want_to_delete_this_mark?": "Weet u zeker dat u deze beoordeling wilt verwijderen?",
            "are_you_sure_you_want_to_go_ahead?": "Weet u zeker dat u wilt doorgaan?",
            "are_you_sure_you_want_to_register_again?": "Weet u zeker dat u opnieuw wilt registeren?",
            "are_you_sure_you_want_to_request_a_review?": "Weet u zeker dat u een beoordeling wilt aanvragen?",
            "are_you_sure_you_want_to_restart_this_elearning?": "Weet u zeker dat u deze e-learning wilt herstarten?",
            "assess_employees": "Medewerkers beoordelen",
            "assessment_result": "Beoordelingsresultaat",
            "assessment_requested": "Beoordeling aangevraagd",
            "assessment_requests": "Beoordelingsaanvragen",
            "assessor": "Beoordelaar",
            "assessors": "Beoordelaars",
            "assessors_are_allowed_to_manage_exemptions": "Beoordelaars mogen vrijstellingen beheren",
            "assign": "Toewijzen",
            "assigned": "Toegewezen",
            "assigned_to": "Toegewezen aan",
            "assignments": "Toewijzingen",
            "attachment(s)": "Bijlage(n)",
            "authorizations": "Autorisaties",
            "back": "Terug",
            "both": "Beide",
            "cancel": "Annuleren",
            "catalogitem_not_found": "Deze activiteit is niet meer beschikbaar.",
            "categories": "Categorieën",
            "category": "Categorie",
            "change_category": "Categorie wijzigen",
            "change_request": "Aanvraag wijzigen",
            "classical": "Klassikaal",
            "classical_theory_lesson": "Klassikale theorieles",
            "clear_all": "Alles wissen",
            "close": "Sluiten",
            "cluster": "Cluster",
            "clusteraction_already_exists": "Er bestaat al een bekwaamheid met dezelfde naam",
            "cluster_already_exists": "Er bestaat al een categorie met dezelfde naam",
            "cluster_not_empty": "De categorie kan niet worden verwijderd omdat er nog één of meedere bekwaamheden in zitten",
            "colleague": "Collega",
            "competence_passport": "Bekwaamheidspaspoort",
            "complete": "Voltooid",
            "completed_on": "Voltooid op",
            "compulsory": "Verplicht",
            "confirm_delete_cluster": "Weet u zeker dat u deze categorie wilt verwijderen?",
            "confirm_delete_clusteraction": "Weet u zeker dat u deze bekwaamheid wilt verwijderen?",
            "confirm_delete_examiner_assignments": "Weet u zeker dat u alle toewijzingen voor deze beoordelaar wilt verwijderen?",
            "confirm_delete_individual_quality": "Weet u zeker dat u deze individuele bekwaamheid wilt verwijderen?",
            "confirm_delete_skill": "Weet u zeker dat u deze bekwaamheid wilt verwijderen?",
            "connected": "Gekoppeld",
            "copy_assessors": "Beoordelaars kopiëren",
            "create_new_skill": "Maak nieuwe bekwaamheid",
            "current_selection": "Huidige selectie",
            "date": "Datum",
            "delete": "Verwijderen",
            "delete_cluster": "Categorie verwijderen",
            "delete_clusteraction": "Bekwaamheid verwijderen",
            "delete_examiner_assignments": "Alle toewijzingen voor deze beoordelaar verwijderen",
            "delete_individual_quality": "Individuele bekwaamheid verwijderen",
            "delete_mark": "Beoordeling verwijderen",
            "delete_skill": "Bekwaamheid verwijderen",
            "deleted": "Verwijderd",
            "department": "Afdeling",
            "departments": "Afdelingen",
            "departments_report": "Afdelingen rapport",
            "description": "Omschrijving",
            "description_(optional)": "Omschrijving (optioneel)",
            "disabled_accounts": "Gedeactiveerde accounts",
            "down": "Omlaag",
            "download": "Downloaden",
            "edit": "Bewerken",
            "edit_cluster": "Categorie bewerken",
            "edit_skill": "Bekwaamheid bewerken",
            "elearning": "e-Learning",
            "employee": "Medewerker",
            "employees": "Medewerkers",
            "empty_values": "Lege waarden",
            "enroll": "Inschrijven",
            "error": "Fout",
            "error_device_time_problem": "Controleer de datum / tijd instelling van je systeem want deze lijkt niet juist te zijn",
            "error_while_saving": "Fout tijdens het opslaan",
            "examiner": "Beoordelaar",
            "examiners": "Beoordelaars",
            "exemption": "Vrijstelling",
            "expiry_date": "Vervaldatum",
            "export_examiner_assignments": "Toewijzingen kopiëren naar andere gebruikers",
            "failed": "Gezakt",
            "filter_by_category_or_skill": "Filter op categorie of bekwaamheid",
            "filter_by_skill": "Filter op bekwaamheid",
            "filter_info_assigned_to": "Filter bekwaamheden op basis van functie of persoonlijke toewijzing",
            "filter_info_connected": "Filter bekwaamheden welke op dit moment gekoppeld zijn op basis van functie of welke persoonlijk zijn toegewezen, of welke op dit moment niet meer zijn toegewezen",
            "filter_info_inapplicable": "Filter bekwaamheden waarbij aangegeven is dat deze niet van toepassing zijn",
            "filter_info_status": "Filter bekwaamheden op status wel of niet bekwaam",
            "filtered_on": "Gefilterd op",
            "for_one_or_more_activities_no_assessors_have_been_added_yet": "Bij één of meerdere activiteiten zijn nog geen beoordelaars toegevoegd",
            "function": "Functie",
            "function_and_individual": "Functie en Individu",
            "functions": "Functies",
            "functions_found": "Functies gevonden",
            "have_you_read_the_manual?": "Heeft u de handleiding gelezen?",
            "have_you_read_the_protocol?": "Heeft u het protocol gelezen?",
            "http(s)_or_ftp_link": "Http(s) of ftp link",
            "import_examiner_assignments": "Toewijzingen overnemen van andere gebruikers",
            "inapplicable": "Niet van toepassing",
            "incomplete": "Onvolledig",
            "individual": "Individueel",
            "individual_skills": "Bekwaamheden individueel",
            "invalid": "Ongeldig",
            "invalid_date": "Ongeldige datum",
            "invalid_examiner": "Ongeldige beoordelaar",
            "it's_not_possible_to_assess_yourself": "Het is niet mogelijk jezelf te beoordelen",
            "last_result": "Laatste resultaat",
            "maintenance": "Onderhoud",
            "maintenance_failed_to_initialize_skills": "Wegens een onverwacht probleem is het bekwaamheidspaspoort momenteel niet beschikbaar. Probeert u het later nog een keer. Onze excuses voor het ongemak.",
            "maintenance_message": "Vanwege onderhoud is het bekwaamheidspaspoort momenteel niet beschikbaar. Probeert u het later nog een keer. Onze excuses voor het ongemak.",
            "managers": "Managers",
            "managers_are_allowed_to_manage_child_departments": "Managers mogen onderliggende afdelingen beheren",
            "managers_are_allowed_to_manage_skill_assignments": "Managers mogen toewijzingen van bekwaamheden beheren",
            "manual": "Handleiding",
            "maximum_validity_reached": "Maximale geldigheid is bereikt",
            "medical_and_technical_aids": "Medische en Technische Hulpmiddelen",
            "month(s)": "Maand(en)",
            "name": "Naam",
            "name_(required)": "Naam (verplicht)",
            "no": "Nee",
            "no_exemption": "Geen vrijstelling",
            "no_results_yet": "Nog geen resultaten",
            "no_skills_available_to_manage_examiners": "Er zijn geen bekwaamheden aanwezig waarvoor u beoordelaars kunt beheren.",
            "non_current_etag": "Het document wat u probeert op te slaan is ondertussen gewijzigd. Hierdoor zijn uw wijzigingen niet opgeslagen.",
            "not_approved": "Niet bekwaam",
            "not_assigned": "Niet toegewezen",
            "not_authorized": "Niet geautoriseerd",
            "not_yet_finalized": "Nog niet afgerond",
            "number_required": "Aantal verplicht",
            "of": "van",
            "off": "Uit",
            "ok": "Ok",
            "on": "Aan",
            "only_add_existing_combinations": "Alleen bestaande combinaties toevoegen",
            "open": "Openen",
            "open_link": "Link openen",
            "optional": "Optioneel",
            "or": "of",
            "passed": "Geslaagd",
            "paste_assessors": "Beoordelaars plakken",
            "peerassessment": "Peer assessment",
            "peer_assessment": "Peer assessment",
            "percentage": "Percentage",
            "practical": "Praktijktoets",
            "practice": "Praktijk",
            "practice_test": "Praktijktoets",
            "preserve_selected_examiners": "Geselecteerde beoordelaars onthouden",
            "progress": "Voortgang",
            "protocol": "Protocol",
            "read": "Gelezen",
            "reason_of_exemption": "Reden van vrijstelling",
            "recommended": "Geadviseerd",
            "register_again": "Opnieuw registeren",
            "remark": "Opmerking",
            "remove_existing_assignments": "Bestaande toewijzingen verwijderen",
            "reports": "Rapporten",
            "request": "Aanvragen",
            "restart": "Opnieuw starten",
            "results": "Resultaten",
            "revoke_request": "Aanvraag intrekken",
            "request_revoked": "Beoordeligsaanvraag ingetrokken",
            "reserved_and_risky_actions": "Voorbehouden en Risicovolle Handelingen",
            "rights": "Rechten",
            "save": "Opslaan",
            "save_and_add_activities": "Opslaan en activiteiten toevoegen",
            "saving_this_record_failed_because_it_was_updated_by_someone_else": "Opslaan van de gegevens is mislukt omdat het item door iemand anders is gewijzigd",
            "search": "Zoeken",
            "search_and_select_functions": "Zoek en selecteer functies",
            "search_for_a_user_with_skills": "Zoek naar een gebruiker met bekwaamheden",
            "search_for_examiners": "Zoek naar beoordelaars",
            "search_for_groups": "Zoek naar groepen",
            "search_for_users": "Zoek naar gebruikers",
            "search_for_users_and/or_groups": "Zoek naar gebruikers en/of groepen",
            "search_for_users_from_your_department": "Zoek naar gebruikers van uw afdeling",
            "search_functions": "Zoek naar functies",
            "searching": "Bezig met zoeken",
            "select": "Selecteer",
            "select_a_skill_to_modify_assignments": "Selecteer een bekwaamheid om toewijzingen aan te passen",
            "select_activity": "Selecteer een activiteit",
            "select_all": "Alles selecteren",
            "select_departments_or_functions": "Selecteer één of meerdere afdelingen en functies",
            "select_department_/_function": "Selecteer afdeling / functie",
            "select_functions": "Selecteer functies",
            "select_an_employee": "Selecteer een medewerker",
            "select_the_colleague_who_is_going_to_assess_your_work": "Selecteer de collega die u gaat beoordelen",
            "selected": "geselecteerd",
            "selected_department_/_function_combinations": "Geselecteerde afdeling / functie combinaties",
            "settings": "Instellingen",
            "show_empty_values": "Toon lege waarden",
            "skill": "Bekwaamheid",
            "skills": "Bekwaamheden",
            "skills_report": "Bekwaamheden rapport",
            "skillslabtest": "Skillslab toets",
            "skillslabtraining": "Skillslab training",
            "skillslab_test": "Skillslab toets",
            "skillslab_training": "Skillslab training",
            "some_mandatory_fields_have_not_yet_been_filled": "Sommige verplichte velden zijn niet ingevuld",
            "specific_departments": "Specifieke afdelingen",
            "specific_functions": "Specifieke functies",
            "status": "Status",
            "successfully_deleted": "Successvol verwijderd",
            "successfully_saved": "Succesvol opgeslagen",
            "the_minimum_number_of_required_activities_is": "Het minimum aantal verplichte activiteiten is",
            "the_result_is_valid_until": "Het resultaat is geldig tot",
            "the_total_files_size_may_not_exceed": "De totale bestandsgrootte mag niet groter zijn dan",
            "total": "Totaal",
            "trainer": "Trainer",
            "trainingonthejob": "Training on the job",
            "training_on_the_job": "Training on the job",
            "type": "Type",
            "up": "Omhoog",
            "update_validity_for_existing_assignments": "Overschrijf geldigheid voor bestaande toewijzingen",
            "valid": "Geldig",
            "validity": "Geldigheid",
            "various": "Diversen",
            "writtentest": "Schriftelijke toets",
            "written_test": "Schriftelijke toets",
            "yes": "Ja"
        };
        
        return function (options) {

            var deferred = $q.defer();
            
            $timeout(function () {
                if (options.key === 'nl')
                    return deferred.resolve(translations.nl);
                return deferred.resolve(translations.en);
            }, 0);

            return deferred.promise;
        };
    }
})();